export default {"src":"/_next/static/image/public/images/ic_rx_gif.97f7f93f06a986542e86bfe8c6be655d.gif","height":417,"width":417};